import Vector from 'toxilibs/vector.js'
import mathText from '../../math_text.js'

let commons = {}

commons.vectors = function (params) {
    let vecU = new Vector(params.uX, params.uY)
    let vecV = new Vector(params.vX, params.vY)

    if (params.angle) {
        vecU = vecU.rotate(params.angle)
        vecV = vecV.rotate(params.angle)
    }

    let u = {
        name: 'U',
        originX: 0,
        originY: 0,
        x: vecU.x,
        y: vecU.y,
        labelUnder: !params.invertLabels,
        color: '#00F'
    }

    let v = {
        name: 'V',
        originX: 0,
        originY: 0,
        x: vecV.x,
        y: vecV.y,
        labelUnder: params.invertLabels,
        color: '#F00'
    }

    return {
        u,
        v
    }
}


commons.displayVectors = function (q, vectors, params) {
    params = params || {}
    let geoScreen = q.addGeoScreen({
        noAxes: true,
        noGrid: params.noGrid
    })

    if (params.angle) {
        geoScreen.drawRotatedGrid({
            orientation: params.angle
        })
    }

    geoScreen.addVector(vectors.u)
    geoScreen.addVector(vectors.v)
}


commons.displayCoords = function (q, vectors) {
    q.addText(mathText.vector(vectors.u))
    q.addText(mathText.vector(vectors.v))
}

commons.question = function (q, vectors) {
    q.addText(mathText.dotProduct(vectors.u, vectors.v) + ' ?')

    // rotated coordinates carry float noise, but the dot product is rotation-invariant: the true answer is an integer
    q.answer = Math.round(vectors.u.x * vectors.v.x + vectors.u.y * vectors.v.y)
}


export default commons


